import NumberFormat from "react-number-format";

const PriceFormat = (props) => {
  const { price, ...rest } = props;
  return (
    <NumberFormat
      value={price}
      displayType={"text"}
      thousandSeparator={true}
      {...rest}
    />
  );
};

export default PriceFormat;
